import {
  useApplyTheme,
  useTheme,
  type Theme,
  type ThemeConfig,
} from '../../shared/theme/useTheme.js'

/**
 * Admin theme — a thin wrapper over the shared `useTheme` primitive
 * (apps/web/src/shared/theme). The admin "ops dashboard" look is dark-first
 * and scoped under `.admin-root` via the `data-admin-theme` <html> attribute,
 * persisted under `naya:admin-theme`.
 */

export type AdminTheme = Theme

const ADMIN_THEME_CONFIG: ThemeConfig = {
  storageKey: 'naya:admin-theme',
  attr: 'data-admin-theme',
  defaultTheme: 'dark',
}

/** Apply the saved admin theme to <html> tree-wide (call once in AdminApp). */
export function useApplyAdminTheme(): void {
  useApplyTheme(ADMIN_THEME_CONFIG)
}

/** Stateful admin theme hook for the header ThemeToggle. */
export function useAdminTheme(): { theme: AdminTheme; toggle: () => void } {
  return useTheme(ADMIN_THEME_CONFIG)
}
